export const AUTH_TOKEN = "auth-token-dietmo";
export const LINKS_PER_PAGE = 5;
export const API_URL =  "https://graphcool.bidiyet.co/simple/v1/ckb2d81za00040192em64a6c6";